import DurationService from "app/services/DurationService";
import { useApiQuery } from "app/modules/api-client";
import { useAdvertiserActivityDataAndParams } from "../../common/hooks/useAdvertiserActivityDataAndParams";

export const useUnifiedChannelMetrics = () => {
    const params = useAdvertiserActivityDataAndParams();
    const { from, to } = DurationService.getDurationData(params.duration).forAPI;

    return useApiQuery(
        {
            tag: "AdIntelligenceOverview",
            methodName: "adIntelligenceAdvertiserUnifiedChannelMetricsList",
        },
        {
            country: params.country,
            key: params.key.split(","),
            from,
            to,
            isWindow: false,
        },
    );
};
